import React from "react";
import * as queryString from "query-string";
import { useReadOnly, useSlate } from "slate-react";
import { Transforms } from "slate";
import * as palette from "@govlaunch/palette";
import { clamp } from "lodash";

const DEFAULT_EMBED_HEIGHT = 200;

export default function GoogleSpreadsheet({ attributes, element, children }) {
  const editor = useSlate();
  const readOnly = useReadOnly();
  const { spreadsheetUrl, adjustedSize, displayHeaders } = element;

  const normalizedUrl = spreadsheetUrl.replace("&amp;", "&");
  const parsed = queryString.parseUrl(normalizedUrl);

  let options = {};

  if (!displayHeaders) {
    options = {
      ...options,
      widget: false,
      chrome: false,
    };
  }

  const embedQuery = queryString.stringify({
    ...options,
    embedded: true,
  });

  const embedUrl = `${parsed.url.replace("/pubhtml", "/pub")}?${embedQuery}`;

  return (
    <div
      css={{
        paddingTop: 10,
      }}
      {...attributes}
    >
      <div
        css={{
          display: "none",
          userSelect: "none",
        }}
      >
        {children}
      </div>
      <div contentEditable={false}>
        {readOnly ? (
          <iframe
            src={embedUrl}
            frameBorder="0"
            style={{
              width: "100%",
              height: adjustedSize || DEFAULT_EMBED_HEIGHT,
            }}
          />
        ) : (
          <div>
            <div
              css={{
                paddingTop: 10,
                width: "90%",
                borderBottom: displayHeaders ? "none" : `solid 1px ${palette.lightSealBlue}`,
              }}
            >
              <div
                css={{
                  marginBottom: displayHeaders ? 0 : 10,
                  display: "flex",
                  width: "100%",
                  userSelect: "none",
                  border: `solid 1px $palette.lightSealBlue}`,
                  borderRadius: 4,
                  borderBottomLeftRadius: displayHeaders ? 0 : 4,
                  borderBottomRightRadius: displayHeaders ? 0 : 4,
                  alignItems: "center",
                  padding: 20,
                }}
              >
                <div
                  css={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div
                    css={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <strong
                      css={{
                        fontWeight: 600,
                        fontSize: 16,
                      }}
                    >
                      Size
                    </strong>

                    <div
                      css={{
                        marginLeft: 5,
                      }}
                    >
                      <input
                        onChange={(event) => {
                          const size = parseInt(event.target.value);

                          if (size) {
                            const newProperties = {
                              adjustedSize: clamp(size, 100, 800),
                            };

                            Transforms.setNodes(editor, newProperties);
                          }
                        }}
                        placeholder="200"
                        css={{
                          outline: "none",
                          border: `solid 1px $palette.lightSealBlue}`,
                          borderRadius: 4,
                          type: "text",
                          padding: 5,
                          width: 60,
                          textAlign: "center",
                          fontSize: 14,
                        }}
                      />
                    </div>
                  </div>

                  <div
                    css={{
                      display: "flex",
                      alignItems: "center",
                      marginLeft: 10,
                    }}
                  >
                    <strong
                      css={{
                        fontWeight: 600,
                      }}
                    >
                      Headers?
                    </strong>

                    <div
                      css={{
                        marginLeft: 5,
                      }}
                    >
                      <input
                        type="checkbox"
                        defaultChecked={displayHeaders}
                        onChange={(event) => {
                          const newProperties = {
                            displayHeaders: event.target.checked,
                          };

                          Transforms.setNodes(editor, newProperties);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <iframe
                src={embedUrl}
                frameBorder="0"
                style={{
                  width: "70%",
                  height: adjustedSize || DEFAULT_EMBED_HEIGHT,
                }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
